/* eslint-disable no-unused-vars */
import * as React from 'react';
import styled from 'styled-components';
import { Palette } from 'config';
import { Message } from 'components';

const BREAKPOINT = '1264px';

const Box = styled.div`
  padding: 0 32px;
`;

const MobileBox = styled(Box)`
  display: none;

  @media (max-width: ${BREAKPOINT}) {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
  }
`;

const DesktopBox = styled(Box)`
  /* @media (max-width: ${BREAKPOINT}) {
    display: none;
  } */
`;

export default function Layout(props) {
  return (
    <>
      <DesktopBox>{props.main}</DesktopBox>
      {/* <MobileBox>
        <Message type='error' isOpen={true}>
          Dear user, use a desktop computer to log in and work in the platform. The platform is not
          optimized for mobile devices at this time.
        </Message>
      </MobileBox> */}
    </>
  );
}
